import { __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { UserPlaceholder, UserPlaceholderWithMask, ClipPathG, RawImage, Wrapper, OnlineStatus } from './styledComponents.mjs';
import { BlackedUserPlaceholder } from './blockedUserPlaceholder.mjs';
import { sizeMap } from './size.mjs';

function UserProfileImageComponent(props) {
  props.userId;
    var size = props.size,
    src = props.src,
    alt = props.alt,
    isOnline = props.isOnline,
    onClick = props.onClick;
    props.ref;
    var elementPaletteProps = props.elementPaletteProps,
    _props$shape = props.shape,
    shape = _props$shape === void 0 ? "round" : _props$shape,
    blockedUser = props.blockedUser,
    rest = __rest(props, ["userId", "size", "src", "alt", "isOnline", "onClick", "ref", "elementPaletteProps", "shape", "blockedUser"]);
  var userPlaceholderElement = React.useMemo(function () {
    return isOnline === undefined ? jsx(UserPlaceholder, {
      size: size,
      elementPaletteProps: elementPaletteProps
    }) : jsx(UserPlaceholderWithMask, {
      size: size,
      elementPaletteProps: elementPaletteProps
    });
  }, [elementPaletteProps, isOnline, size]);
  var userProfileElement = React.useMemo(function () {
    if (blockedUser) {
      return jsx(BlackedUserPlaceholder, {
        size: size,
        elementPaletteProps: elementPaletteProps
      });
    }
    if (!src) {
      return userPlaceholderElement;
    }
    return isOnline !== undefined ? jsx("svg", {
      width: sizeMap.get(size),
      height: sizeMap.get(size),
      children: jsx(ClipPathG, {
        size: size,
        href: src,
        children: jsx("image", {
          width: sizeMap.get(size),
          height: sizeMap.get(size),
          xlinkHref: src
        })
      })
    }) : jsx(RawImage, {
      alt: alt !== null && alt !== void 0 ? alt : src,
      size: size,
      src: src,
      "aria-label": "user profile image",
      shape: shape,
      elementPaletteProps: elementPaletteProps
    });
  }, [alt, blockedUser, elementPaletteProps, isOnline, shape, size, src, userPlaceholderElement]);
  return jsxs(Wrapper, Object.assign({
    size: size
  }, rest, {
    onClick: onClick,
    children: [userProfileElement, isOnline !== undefined && !blockedUser ? jsx(OnlineStatus, {
      isOnline: isOnline
    }) : null]
  }));
}
var UserProfileImage = /*#__PURE__*/React.memo(UserProfileImageComponent);

export { UserProfileImage };
